export default "__VITE_ASSET__DkepmHWJ__"